// src/components/SignUp.js
import React, { useState } from 'react';
import { createUserWithEmailAndPassword, signInWithPopup } from "firebase/auth";
import { useNavigate } from 'react-router-dom';
import { auth, provider, db } from '../firebaseConfig';
import { doc, setDoc } from "firebase/firestore";
import { FcGoogle } from 'react-icons/fc';
import '../styles/LoginSignup.css'; // Assumindo que você tenha um CSS compartilhado



const SignUp = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [dob, setDob] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [isNewUser, setIsNewUser] = useState(false);
  const navigate = useNavigate();

  const handleSignUp = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      setIsNewUser(true); // Ativa o formulário de captura de informações adicionais
    } catch (error) {
      setError('Erro ao criar conta: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleSignUp = async () => {
    setLoading(true);
    setError('');
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      setIsNewUser(true); // Ativa o formulário de captura de informações adicionais
    } catch (error) {
      setError('Erro ao criar conta com Google: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSaveUserInfo = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const user = auth.currentUser;
      await setDoc(doc(db, "users", user.uid), {
        name,
        dob,
        email: user.email,
        company: "Nome da Empresa", // Substitua com a lógica para capturar a empresa correta
        uid: user.uid
      });

    } catch (error) {
      setError('Erro ao salvar informações: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  if (isNewUser) {
    return (
      <div className="signup-container">
        <h2>Complete suas informações</h2>
        <form onSubmit={handleSaveUserInfo}>
          <div className="input-group">
            <input
              required
              type="text"
              name="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="input"
              autoComplete="off"
            />
            <label className="user-label">Nome *</label>
          </div>
          <div className="input-group">
            <input
              required
              type="date"
              name="dob"
              value={dob}
              onChange={(e) => setDob(e.target.value)}
              className="input"
              autoComplete="off"
            />
            <label className="user-label">Data de Nascimento *</label>
          </div>
          <button
            type="submit"
            className="submit-button"
            disabled={loading}
          >
            {loading ? 'Salvando...' : 'Salvar'}
          </button>
          {error && <p className="error">{error}</p>}
        </form>
      </div>
    );
  }

  return (
    <div className="signup-container">
      <h2>Criar Conta</h2>
      <form onSubmit={handleSignUp}>
        <div className="input-group">
          <input
            required
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="input"
            autoComplete="off"
          />
          <label className="user-label">E-mail *</label>
        </div>
        <div className="input-group">
          <input
            required
            type="password"
            name="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="input"
            autoComplete="off"
          />
          <label className="user-label">Senha *</label>
        </div>
        <button
          type="submit"
          className="submit-button"
          disabled={loading}
        >
          {loading ? 'Criando...' : 'Criar conta'}
        </button>
      </form>
      <button
        onClick={handleGoogleSignUp}
        className="google-signup-button"
        disabled={loading}
      >
        <FcGoogle size={20} style={{ marginRight: '8px' }} />
        {loading ? 'Criando...' : 'Criar conta com Google'}
      </button>
      {error && <p className="error">{error}</p>}
      <p className="signup-prompt">
      Já possui uma conta? <a onClick={() => navigate('/')}>Acesse sua conta</a>
      </p>
    </div>
  );
};

export default SignUp;
